// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { LazyImageStyle } from "@awc/MobiusOverrides/LazyImage";
import { primaryImageStyles } from "@awc/Overrides/Widgets/ProductDetails/ProductDetailsPrimaryImage";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { ellipsis, mergeWithCss, sharedBadgeStyle } from "@awc/XDL/Utilities";
import { css } from "styled-components";

primaryImageStyles.fullPrimaryImageModal = {};

primaryImageStyles.badgeContainer = {
    css: css`
        &&&& {
            ${LazyImageStyle} {
                width: 40px;
                height: 40px;
                aspect-ratio: 1;
            }
        }
    `,
};

primaryImageStyles.badgeAreaWrapper = {
    css: css`
        position: relative;
    `,
};

primaryImageStyles.imgWrapper = {
    css: css`
        position: relative;
        width: fit-content;
    `,
};

primaryImageStyles.primaryImage = {
    centeringWrapper: {
        css: css`
            min-height: 216px;
            max-width: 216px;
            aspect-ratio: 1;
            margin: 0;
        `,
    },
    img: {
        css: css`
            width: 100%;
            aspect-ratio: 1;
            cursor: auto;
        `,
    },
};

primaryImageStyles.fullPrimaryImage = {
    ...primaryImageStyles.fullPrimaryImage,
    img: {
        css: css`
            width: auto;

            &&& {
                max-height: 70vh;
            }
        `,
    },
};

primaryImageStyles.badgeTextWrapper = {
    css: css`
        position: absolute;
        white-space: nowrap;
        overflow: hidden;
        border-radius: 2px;
        & > div {
            padding: 4px 6px;
            display: flex;
        }
    `,
};

primaryImageStyles.badgeText = {
    size: fontConfig.fontSize.xxSmall,
    weight: fontConfig.weight.bold,
    lineHeight: fontConfig.lineHeight.xxSmall,
};

primaryImageStyles.fullPrimaryImageModal = {
    mergeCss: true,
    cssOverrides: {
        modalTitle: css`
            &:after {
                display: none;
            }
        `,
    },
};

primaryImageStyles.badgeImageProps = {
    width: "40px",
    height: "40px",
};

primaryImageStyles.customProductBadge = {
    textBadgeWrapperCss: {
        css: css`
            max-width: 216px;
        `,
    },
    textBadgeCss: {
        ...mergeWithCss(sharedBadgeStyle.badgeText, {
            css: css`
                ${ellipsis(1)}
            `,
        }),
    },
};
